import { render, staticRenderFns } from "./EventsChart.vue?vue&type=template&id=cd8b9116&scoped=true"
import script from "./EventsChart.vue?vue&type=script&lang=js"
export * from "./EventsChart.vue?vue&type=script&lang=js"
import style0 from "./EventsChart.vue?vue&type=style&index=0&id=cd8b9116&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd8b9116",
  null
  
)

export default component.exports